import { Button } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import LabeledSliderInput from "components/Form/LabeledSliderInput";
import LabeledTextArea from "components/Form/LabeledTextArea";
import useNewsBroadcast from "hooks/broadcasts/useNewsBroadcast";
import { PiSpeakerSimpleNone } from "react-icons/pi";

export default function NewBroadcast() {
  const { control, handleSubmit, loading, onSubmit, watchTo } =
    useNewsBroadcast();

  return (
    <div className="w-full bg-white rounded-lg p-6 shadow-lg">
      <div className="pt-5 pb-5">
        <h1 className="p-5 font-light text-lg text-center">New Broadcast</h1>
        <div className="w-full">
          <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
            <div className="w-1/2 bg-black h-full rounded-md"></div>
          </div>
          <div className="relative w-full flex justify-center">
            <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
              <PiSpeakerSimpleNone />
            </div>
          </div>
        </div>
        <p className="text-center mt-2 text-sm font-normal">New Broadcast</p>
      </div>
      <div className="py-8 px-5">
        <form onSubmit={handleSubmit(onSubmit)} className="mx-auto max-w-xl">
          <div className="w-full flex flex-wrap">
            <div className="w-full  px-4 pt-5">
              <LabeledInput
                label="Title"
                type="text"
                control={control}
                name="title"
                placeholder="Enter title"
              />
            </div>
            <div className=""></div>
            <div className="w-full  px-4 pt-5">
              <LabeledSelectInput
                control={control}
                label="Send To"
                name="to"
                options={[
                  { label: "Drivers", value: "driver" },
                  { label: "Passengers", value: "passenger" },
                  { label: "All", value: "all" },
                ]}
                placeholder="Select to whom you want to send"
              />
            </div>
            {watchTo === "driver" && (
              <>
                <div className="w-full  px-4 pt-5">
                  <LabeledSelectInput
                    control={control}
                    label="Fleet Category"
                    name="fleet_category"
                    placeholder="Select Category (Optional)"
                    allowClear
                    options={[
                      { label: "Engine", value: "engine" },
                      { label: "EV", value: "ev" },
                      { label: "Megala", value: "megala" },
                      { label: "Proto", value: "proto" },
                      { label: "Megala Engine", value: "megala engine" },
                      { label: "Megala EV", value: "megala ev" },
                      { label: "Proto Engine", value: "proto engine" },
                      { label: "Proto EV", value: "proto ev" },
                    ]}
                  />
                </div>
                <div className=""></div>
                <div className="w-full  px-4 pt-5">
                  <LabeledSliderInput
                    control={control}
                    label="Driver Age Range"
                    name="driver_age"
                    max={90}
                    min={18}
                  />
                </div>
                <div className=""></div>
                <div className="w-full  px-4 pt-5">
                  <LabeledSliderInput
                    control={control}
                    label="Driver Vehicle Production Year Range"
                    name="fleet_production_year"
                    min={2000}
                    max={new Date().getFullYear()}
                  />
                </div>
              </>
            )}
            <div className=""></div>
            <div className="w-full px-4 pt-5 ">
              <LabeledTextArea
                placeholder="Enter your message"
                control={control}
                label="Message Content"
                name="content"
                rows={6}
              />
            </div>
          </div>
          <div className="w-full flex mt-8 justify-end px-4">
            <Button
              loading={loading}
              htmlType="submit"
              type="primary"
              className="py-2 px-16 rounded-md h-auto font-semibold"
            >
              Send
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
